export enum DeletionRequestStatus {
  noStatus = 'noStatus',
  requestProcessing = 'requestProcessing',
  deletionRequested = 'deletionRequested',
  hasErrored = 'error',
}
